import React from 'react';
import { toast } from 'sonner';

import { HandleCard, type HandleData } from './HandleCard';

interface GenericHandleListPanelProps<THandle extends HandleData> {
  entityName: string;
  handles: THandle[];
  onSelect: (handle: THandle) => void;
  actions?: ('copy' | 'use')[];
}

/**
 * Generic handle list panel for right side of pocketbook
 * Works with any entity that has handles (carriers, providers, police depts)
 */
export const GenericHandleListPanel = <THandle extends HandleData>({
  entityName,
  handles,
  onSelect,
  actions = ['copy', 'use'],
}: GenericHandleListPanelProps<THandle>) => {
  const handleCopy = async (value: string, handleName: string) => {
    await navigator.clipboard.writeText(value);
    toast.success(`Copied ${handleName}`);
  };

  if (handles.length === 0) {
    return (
      <div>
        <h3 className="font-semibold text-gray-900 mb-3">{entityName}</h3>
        <div className="text-sm text-gray-500">
          No contact information available
        </div>
      </div>
    );
  }

  return (
    <div>
      <h3 className="font-semibold text-gray-900 mb-3">{entityName}</h3>

      <div className="space-y-3">
        {handles.map((handle) => (
          <HandleCard
            key={handle.id}
            handle={handle}
            onCopy={handleCopy}
            onSelect={() => onSelect(handle)}
            actions={actions}
          />
        ))}
      </div>
    </div>
  );
};
